import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { ZeitArtsQuerySorterConfig } from 'fa-kt.types';
import { ZeitArtsService } from '../service';

@Component({
  selector: 'fa-kt-zeit-arts-sorter',
  templateUrl: './zeit-arts-sorter.component.html',
  styleUrls: ['./zeit-arts-sorter.component.css'],
})
export class ZeitArtsSorterComponent {
  ZeitArtsSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public zeitArts: ZeitArtsService,
  ) {
    this.ZeitArtsSorterConfig = ZeitArtsQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
